import { render, staticRenderFns } from "./BasicInformationCard.vue?vue&type=template&id=1344a4b9&"
import script from "./BasicInformationCard.vue?vue&type=script&lang=js&"
export * from "./BasicInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports